(function ($) {
  "use strict";
  jQuery(document).ready(function(){

document.onkeydown = function(e) {
  if(event.keyCode == 123) {
    return false;
  }
  if(e.ctrlKey && e.shiftKey && e.keyCode == 'I'.charCodeAt(0)) {
    return false;
  }
  if(e.ctrlKey && e.shiftKey && e.keyCode == 'C'.charCodeAt(0)) {
    return false;
  }
  if(e.ctrlKey && e.shiftKey && e.keyCode == 'J'.charCodeAt(0)) {
    return false;
  }
  if(e.ctrlKey && e.keyCode == 'U'.charCodeAt(0)) {
    return false;
  }
}
$(document).ready(function(){
    $("button.navbar-toggler").click(function(){
      $(".main-menu-area").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
      $("body").addClass("hidden");
    });
    $(".close-box").click(function(){
      $(".main-menu-area").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("hidden");
    });
    $(".mm-fullscreen-bg").click(function(){
      $(".main-menu-area").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("hidden");
    });
});
$(document).ready(function(){
  $('[data-toggle="tooltip"]').tooltip();
});

/*--
Magnific Popup
------------------------*/
$('.product-main-img').magnificPopup({
  delegate: 'a',
  type: 'image',
  showCloseBtn: true,
  closeBtnInside: false,
  midClick: true,
  tLoading: 'Loading image #%curr%...',
  mainClass: 'mfp-img-mobile',
  gallery: {
    enabled: true,
    navigateByImgClick: true,
  preload: [0,1] // Will preload 0 - before current, and 1 after the current image
},
image: {
  tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
}
});
$('.play-button, .popup-vimeo, .popup-gmaps').magnificPopup({
    tClose: 'Close (Esc)',
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
});
    
$(window).scroll(function(){
  if ($(this).scrollTop() > 1000) {
    $('#top').fadeIn();
  } else {
    $('#top').fadeOut();
  }
});
$('#top').click(function(){
  $("html, body").animate({ scrollTop: 0 }, 600);
  return false;
});
});
})(jQuery);

document.addEventListener('scroll', function () {
  const header = document.querySelector('.header-area');
  if (window.scrollY > 50) {
    header.classList.add('scrolled');
  } else {
    header.classList.remove('scrolled');
  }
});

$(window).on("load", function () {

  /* Search Page or Instant Search: If the product metafield 'loginToView' has a 'Yes' value */
  function updateSnizePrice() {
    const snizePriceLists = $('.snize-product .snize-price-list');
     snizePriceLists.css('opacity','1');
    if (!window.dataObject.customer) {
        const snizeAttribute = $('.snize-product .snize-attribute');
        const snizePrice = snizeAttribute.parent().find('.snize-price-list');
        snizePrice.html(window.dataObject.loginToView);
    }
  }

  updateSnizePrice();

  if (!window.dataObject.customer) {
      $(document).on('click input keydown focus', '#search-crap [type="search"]', () => {
          [1000, 2000, 3000, 4000].forEach(delay => setTimeout(updateSnizePrice, delay));
      });
  }
  /* end Search Page or Instant Search */


  /* Wishlist Page: If the product metafield 'loginToView' has a 'Yes' value */
  async function updateBookmarks() {
    const bookmarks = $('#bookmarks .product_title a').toArray(); // Convert jQuery object to an array

    for (const product of bookmarks) {
        const url = $(product).attr('href');

        try {
            const response = await fetch(`${url}&sections=product-template`);
            const res = await response.json();

            const result = res['product-template'];
            const html = new DOMParser().parseFromString(result, 'text/html').querySelector('.product-details-page');
            const metafieldLogin = html.getAttribute('loginForPrice');

            const priceElement = $(product).closest('.product').find('p .price');

            if (!window.dataObject.customer && metafieldLogin === 'Yes') {
                priceElement.replaceWith(window.dataObject.loginToView);
            } else {
                priceElement.css('opacity', '1');
            }
        } catch (error) {
            console.error('Error fetching product data:', error);
        }
    }
  }

  updateBookmarks();
  /* end Wishlist Page */

})
window.addEventListener('load', function () {
  try {
      if (window.innerWidth > 768) return;

      const shopifyInboxOnlineChat = document.querySelector('inbox-online-store-chat');
      if (!shopifyInboxOnlineChat || !shopifyInboxOnlineChat.shadowRoot) return;

      const chatStyle = document.createElement('style');
      chatStyle.textContent = `button.chat-toggle { display: none !important; }`;
      shopifyInboxOnlineChat.shadowRoot.appendChild(chatStyle);

      const supportButton = document.querySelector('.site-footer .footer-pane-item.support');
      if (!supportButton) return;

      supportButton.addEventListener('click', evt => {
          evt.preventDefault();
          const chatToggleButton = shopifyInboxOnlineChat.shadowRoot.querySelector('button.chat-toggle');
          if (!chatToggleButton) return;
          chatToggleButton.click();
      });
         snizePriceLists.css({opacity:'1'});

  } catch (error) {
      console.error("An error occurred:", error);
  }
});